(function () {
  'use strict';

  function initialiseProduct(root) {
    if (root.dataset.cafeReady === 'true') return;
    const data = root.querySelector('[data-cafe-variants]');
    const select = root.querySelector('[data-cafe-variant]');
    const price = root.querySelector('[data-cafe-price]');
    const submit = root.querySelector('[data-cafe-submit]');
    const status = root.querySelector('[data-cafe-status]');
    const quantity = root.querySelector('[data-cafe-quantity-input]');
    if (!data || !select || !quantity || !submit) return;
    let variants;
    try { variants = JSON.parse(data.textContent); } catch (_) { return; }
    root.dataset.cafeReady = 'true';
    const variantById = new Map(variants.map((variant) => [String(variant.id), variant]));
    const thumbnails = Array.from(root.querySelectorAll('[data-cafe-thumbnail]'));
    const mainImage = root.querySelector('.lc-product-main-image');
    const quantityButtons = Array.from(root.querySelectorAll('[data-cafe-quantity]'));

    function showImage(button, revealThumbnail) {
      if (!button || !mainImage) return;
      mainImage.removeAttribute('srcset');
      mainImage.src = button.dataset.imageSrc;
      mainImage.alt = button.dataset.imageAlt || '';
      thumbnails.forEach((thumbnail) => {
        const selected = thumbnail === button;
        thumbnail.classList.toggle('is-selected', selected);
        thumbnail.setAttribute('aria-pressed', String(selected));
      });
      if (revealThumbnail) {
        const rail = button.parentElement;
        const railBounds = rail.getBoundingClientRect();
        const buttonBounds = button.getBoundingClientRect();
        if (buttonBounds.left < railBounds.left || buttonBounds.right > railBounds.right) {
          rail.scrollTo({
            left: rail.scrollLeft + buttonBounds.left - railBounds.left,
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          });
        }
      }
    }

    function selectedVariant() {
      return variantById.get(select.value);
    }

    function synchroniseQuantityButtons() {
      const minimum = Number(quantity.min) || 1;
      const maximum = quantity.hasAttribute('max') ? Number(quantity.max) : Infinity;
      const current = Number(quantity.value) || minimum;
      quantityButtons.forEach((button) => {
        button.disabled = quantity.disabled || (button.dataset.cafeQuantity === 'minus' ? current <= minimum : current >= maximum);
      });
    }

    function updateVariant(updateUrl, updateImage) {
      const variant = selectedVariant();
      if (!variant) {
        submit.disabled = true;
        submit.setAttribute('aria-disabled', 'true');
        submit.textContent = 'Combinación no disponible';
        status.textContent = 'Esta combinación no está disponible.';
        return;
      }
      if (price) price.textContent = variant.price;
      submit.disabled = !variant.available;
      submit.setAttribute('aria-disabled', String(!variant.available));
      submit.textContent = variant.available ? 'Añadir al carrito' : 'Agotado';
      status.textContent = variant.available ? 'Variante disponible.' : 'La variante seleccionada está agotada.';
      quantity.min = String(variant.min || 1);
      quantity.step = String(variant.step || 1);
      quantity.disabled = !variant.available;
      const minimum = variant.min || 1;
      const step = variant.step || 1;
      let nextQuantity = Math.max(minimum, Number(quantity.value) || minimum);
      nextQuantity = minimum + Math.floor((nextQuantity - minimum) / step) * step;
      if (Number.isFinite(variant.max) && variant.max >= minimum) {
        quantity.max = String(variant.max);
        const highestValidQuantity = minimum + Math.floor((variant.max - minimum) / step) * step;
        nextQuantity = Math.min(nextQuantity, highestValidQuantity);
      } else {
        quantity.removeAttribute('max');
      }
      quantity.value = String(nextQuantity);
      const variantThumbnail = thumbnails.find((thumbnail) => thumbnail.dataset.mediaId === String(variant.mediaId));
      if (updateImage && variantThumbnail) showImage(variantThumbnail, true);
      synchroniseQuantityButtons();
      if (updateUrl && window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', String(variant.id));
        window.history.replaceState({}, '', url);
      }
    }

    thumbnails.forEach((thumbnail) => thumbnail.addEventListener('click', () => showImage(thumbnail)));
    select.addEventListener('change', () => updateVariant(true, true));
    quantityButtons.forEach((button) => {
      button.addEventListener('click', () => {
        if (quantity.disabled) return;
        if (button.dataset.cafeQuantity === 'plus') quantity.stepUp();
        else quantity.stepDown();
        quantity.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    quantity.addEventListener('change', synchroniseQuantityButtons);
    quantity.addEventListener('input', synchroniseQuantityButtons);
    root.querySelector('form').addEventListener('submit', (event) => {
      const variant = selectedVariant();
      if (!variant || !variant.available) {
        event.preventDefault();
        status.textContent = 'La variante seleccionada está agotada.';
      }
      // Available variants keep Shopify's native POST /cart/add flow.
      // No duplicate analytics events, AJAX cart recreation or checkout calls.
    });
    // Keep the product's editorial featured image on a clean product URL.
    // A valid explicit variant URL or a new selection uses that variant's image.
    const requestedVariantId = new URL(window.location.href).searchParams.get('variant');
    const hasRequestedVariant = requestedVariantId && variantById.has(requestedVariantId);
    if (hasRequestedVariant) select.value = requestedVariantId;
    updateVariant(false, Boolean(hasRequestedVariant));
  }

  function initialiseAll(scope) {
    scope.querySelectorAll('[data-cafe-product]').forEach(initialiseProduct);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialiseAll(document));
  else initialiseAll(document);
  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();
